import { CommonRootState } from '@common/types/common-root-state-type';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { NotifierService } from './NotifierService';
import { updateConnectedSockets } from '../reducers/ConnectedEnginesSlice';
import { MQTTSubscriber } from './MQTTSubscriber';

// Backward compatibility export
export const connectNotifier = createAsyncThunk<void, { accessToken: string }, { state: CommonRootState }>(
  'notifier/connectNotifier',
  async ({ accessToken }) => {
    const notifier = NotifierService.getInstance();
    notifier.connect(accessToken);
  }
);

export const disconnectNotifier = createAsyncThunk<void, void, { state: CommonRootState }>(
  'notifier/disconnect',
  async (_, thunkApi) => {
    const dispatch = thunkApi.dispatch;
    const notifier = NotifierService.getInstance();
    notifier.disconnect();
    dispatch(updateConnectedSockets([]));
  }
);

export const notifierLogoutThunk = createAsyncThunk<void, string, { state: CommonRootState }>("notifier/logout", async (socketId, thunkApi) => {
  console.log('[Notifier] Logout operations not supported via MQTT, use HTTP API instead');
  // TODO: Replace with HTTP API call if needed
});

export const notifierSubscribeThunk = createAsyncThunk<void, { entityType: string; entityId: string }, { state: CommonRootState }>("notifierSubscribeThunk", async (params, thunkApi) => {
  const { entityType, entityId } = params;
  
  if (entityType === 'boards' || entityType === 'workspaces') {
    const mqttSubscriber = MQTTSubscriber.getInstance();
    
    if (mqttSubscriber.isConnected()) {
      mqttSubscriber.subscribeToEntity(entityType, entityId);
      console.log(`[Notifier] Subscribed to ${entityType}: ${entityId}`);
    } else {
      console.warn(`[Notifier] Cannot subscribe to ${entityType} ${entityId} - MQTT not connected`);
    }
  } else {
    console.log(`[Notifier] Entity type ${entityType} not supported for MQTT subscription`);
  }
});

export const identifySocketThunk = createAsyncThunk<
  void,
  string,
  { state: CommonRootState }
>("notifier/identify", async (socketId, thunkApi) => {
  console.log('[Notifier] Socket identification not applicable with MQTT');
  // Not applicable for MQTT
});

export const subscribeToDashboardThunk = createAsyncThunk<void, void, { state: CommonRootState }>("notifier/subscribe-dashboard", async (_, thunkApi) => {
  console.log('[Notifier] Dashboard subscription handled automatically via MQTT topics');
  // Dashboard topics are automatically subscribed if user has admin permissions
});

